import * as React from "react";
import { Suspense, useState } from "react";
import { CloseButton, Dropdown } from "react-bootstrap";
import { BsNewspaper } from "react-icons/bs";
import { useCustomerServiceContactGroupQuery } from "../../../hooks/useCustomerServiceContactGroupQuery";

export const RequestAQuote = () => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <Dropdown
            id="quoteToggle"
            show={isOpen}
            onToggle={() => setIsOpen(!isOpen)}
            aria-haspopup="true"
        >
            <Dropdown.Toggle
                variant="outline-primary"
                size="sm"
                id="quote-dropdown-toggle"
                className="d-flex align-items-center"
                aria-expanded={isOpen ? 'true' : 'false'} // Updated aria-expanded here
                aria-label="Need a Quote? Quote Information DropDown"
            >
                Need a Quote?
            </Dropdown.Toggle>
            <Dropdown.Menu
                className="p-3"
                style={{ width: '350px' }}
            >
                <div className="d-flex justify-content-between align-items-center border-bottom pb-3">
                    <strong className="fs-5" id="request-quote-dropdown">
                        Need a Quote?
                    </strong>
                    <CloseButton
                        aria-label="Close"
                        className="fs-5"
                        onClick={() => setIsOpen(false)}
                    />
                </div>
                <div className="border-bottom pt-3">
                    <p>
                        For bulk quantity pricing or quantities that exceed what we have in stock, please contact us at{' '}
                        <Suspense fallback={<></>}>
                            <PhoneNumber />
                        </Suspense>
                    </p>
                </div>
                <div className="pt-3">
                    <strong>Steps to create an instant quote:</strong>
                    <ol>
                        <li>Fill your cart with your desired items and quantities.</li>
                        <li>Click the ‘Email Quote / Invoice’ button in the top right corner of your cart.</li>
                        <li>Your quote / invoice will be emailed to you.</li>
                        <li>Call us when you’re ready to order!</li>
                    </ol>
                </div>
            </Dropdown.Menu>
        </Dropdown>

    )
}

const PhoneNumber = () => {
    const { model } = useCustomerServiceContactGroupQuery();
    return model?.phone ? <a href={`tel:+${model.phone}`} tabIndex={0} role="link" aria-label="telephone number link">{model.phone}</a> : <></>;
}